import React from 'react'
import * as clipboard from 'clipboard-polyfill/text'

interface Props {
  id: string
  value: string
}

export const CopyLinkWidget: React.FC<Props> = ({ id, value }) => {
  const baseUrl = `${window.location.origin}${window.location.pathname}`
  const link = `${baseUrl}?token=${value}`

  return (
    <span
      style={{
        display: 'flex',
        flexDirection: 'row',
        width: 'calc(80% - 26px)'
      }}
    >
      <input
        id={id}
        readOnly
        value={link}
        style={{ flex: 3 }}
        className="form-control"
        data-test="tokens-for-access-link"
      />
      <div
        className="btn btn-default"
        title="Copy public comment link"
        data-test="tokens-for-access-button-copy-link"
        style={{ marginLeft: 15, alignSelf: 'flex-end' }}
        onClick={() => {
          clipboard
            .writeText(link)
            .catch(err => console.warn('Cannot copy access token info to the clipboard', err))
        }}
      >
        Copy Link
      </div>
    </span>
  )
}
